import { Locale } from '.';

export type LocaleDirection = 'ltr' | 'rtl';

/** Get content direction from locale */
export function getContentDirection(
  locale: Locale,
  hostContentDirection?: LocaleDirection,
  componentContentDirection?: LocaleDirection
): LocaleDirection {
  if (componentContentDirection) {
    return componentContentDirection;
  }

  if (hostContentDirection) {
    return hostContentDirection;
  }

  return getLocaleDirection(locale);
}

/** Get UI direction from locale */
export function getUIDirection(locale: Locale): LocaleDirection {
  return getLocaleDirection(locale);
}

function getLocaleDirection(locale: Locale): LocaleDirection {
  switch (locale) {
    case 'ar-sa':
    case 'fa-ir':
    case 'he-il':
    case 'ug-cn':
    case 'ur-pk':
      return 'rtl';
    default:
      return 'ltr';
  }
}
